export default "__VITE_ASSET__BzI8wfDf__"